export const DETAILED_IMAGE_AUTHORING_INPUT_TYPE_UPLOAD =
  'DETAILED_IMAGE_AUTHORING_INPUT_TYPE_UPLOAD';
export const DETAILED_IMAGE_AUTHORING_INPUT_TYPE_URL =
  'DETAILED_IMAGE_AUTHORING_INPUT_TYPE_URL';
export const DETAILED_IMAGE_AUTHORING_INPUT_TYPE_EDIT =
  'DETAILED_IMAGE_AUTHORING_INPUT_TYPE_EDIT';
